// extracted by mini-css-extract-plugin
module.exports = {"starContainer":"SingleStar__starContainer__1-ExL","starBase":"SingleStar__starBase__2u3ed","empty":"SingleStar__empty__1SXFy","full":"SingleStar__full__3osH1"};